// components/common/Tooltip/Tooltip.tsx
import React from "react";
import styles from "./Tooltip.module.scss";

interface TooltipProps {
  content: string;
  isVisible: boolean;
}

export const Tooltip: React.FC<TooltipProps> = ({ content, isVisible }) => {
  if (!isVisible) {
    return null;
  }

  return (
    <div className={styles.tooltipContainer}>
      <div className={styles.tooltipContent}>{content}</div>
      <div className={styles.tooltipArrow} />
    </div>
  );
};
